import React from 'react';
import {Layout} from '@di-nxt/components';
import {AbsenceProps} from './types';
import {ScheduleCalendarType} from '../../services';

export const Absence: React.FC<AbsenceProps> = ({kind}) => {
  return (
    <Layout align="center" height={styleMap[kind].height}>
      <Layout
        backgroundColor="background_mono_primary"
        borderStyle="solid"
        borderColor="border_mono_30"
        borderWidth="1"
        flex
        absolute
        overflow="hidden"
        align="center"
        borderRadius="4"
      />
    </Layout>
  );
};

const styleMap: {[key in ScheduleCalendarType]: {height: number}} = {
  day: {
    height: 36,
  },
  week: {
    height: 24,
  },
  month: {
    height: 24,
  },
};
